export const injectMetadata = (action, metadata) => {
  return (...args) => ({
    ...action(...args),
    metadata
  });
};
